import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { formatDate } from "@/lib/constants";
import { Calendar, Users, AlertCircle, FileText, ArrowRight } from "lucide-react";

export default function Dashboard() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/dashboard").then((r) => setData(r.data));
  }, []);
  if (!data) return <p className="text-[#292522]/50">Caricamento…</p>;

  const stats = [
    { label: "Prenotazioni totali", value: data.total_bookings, icon: Users, cls: "bg-[#FF6100] text-white" },
    { label: "Eventi in bozza", value: data.draft_events, icon: Calendar, cls: "bg-white text-[#292522]" },
    { label: "Articoli non pubblicati", value: data.draft_articles, icon: FileText, cls: "bg-white text-[#292522]" },
    { label: "Eventi quasi pieni", value: data.events_almost_full.length, icon: AlertCircle, cls: "bg-[#216B65] text-white" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="flex items-end justify-between gap-4 mb-8">
        <div>
          <h1 className="font-display text-4xl font-medium">Dashboard</h1>
          <p className="text-sm text-[#292522]/60 mt-1">Uno sguardo veloce a ciò che succede su Vola Vola.</p>
        </div>
        <Link to="/admin/eventi" className="btn-primary text-sm" data-testid="dash-new-event">+ Nuovo evento</Link>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((s) => {
          const Icon = s.icon;
          return (
            <div key={s.label} className={`rounded-2xl p-6 ${s.cls}`}>
              <Icon className="h-6 w-6 mb-3" strokeWidth={1.5} />
              <div className="text-3xl font-display font-medium">{s.value}</div>
              <div className="text-xs opacity-75 mt-1">{s.label}</div>
            </div>
          );
        })}
      </div>

      <div className="mt-10">
        <h2 className="font-display text-2xl font-medium mb-4">Prossimi eventi</h2>
        <div className="rounded-2xl bg-white overflow-hidden border border-[#292522]/8">
          {data.upcoming.length === 0 ? (
            <div className="p-6 text-sm text-[#292522]/60">Nessun evento in programma.</div>
          ) : (
            <ul className="divide-y divide-[#292522]/8">
              {data.upcoming.map((ev) => (
                <li key={ev.id} className="p-4 flex items-center justify-between gap-4">
                  <div>
                    <div className="font-semibold text-[#292522]">{ev.title}</div>
                    <div className="text-xs text-[#292522]/60 mt-1">{formatDate(ev.start_date)} · {ev.location}</div>
                  </div>
                  <span className="text-xs rounded-full bg-[#FFF1E8] text-[#FF6100] font-semibold px-3 py-1">{ev.status}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {data.events_almost_full.length > 0 && (
        <div className="mt-10">
          <h2 className="font-display text-2xl font-medium mb-4">Eventi quasi pieni</h2>
          <div className="grid gap-3 sm:grid-cols-2">
            {data.events_almost_full.map((ev) => (
              <div key={ev.id} className="rounded-2xl bg-[#FF6100]/10 p-5 border border-[#FF6100]/30">
                <div className="font-semibold">{ev.title}</div>
                <div className="text-xs text-[#292522]/70 mt-1">{ev.seats_taken}/{ev.capacity} posti occupati</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
